import {getTokenObj} from "@/mixins/Auth";
import util from "@/mixins/util";
import {LevelClass} from "@/mixins/level";
import {
    clearLoginState,
    getLoginErrorMessage,
    getLoginLevelObj,
    isAllowedLoginGroupType,
} from "@/mixins/loginAccess";

export default {
    data() {
        return {
            redirect: '/',
            LevelClass: new LevelClass(),
        }
    },
    methods: {
      checkLevel() {
          let tokenObj = getTokenObj();
          this.$api.$config.getGroup().then(res => res.Data.Result).then(res => {
              if(res.Info.type != 1 || util.isEmpty(tokenObj) || util.isEmpty(tokenObj.g_idx)) {
                  this.checkLevelFail();
              } else {
                  let g_idx = tokenObj.g_idx;
                  let groupList = res.List;
                  this.makeGroupObj(g_idx, groupList);
              }
          }).catch(() => {
              this.checkLevelFail();
          })
      },
        makeGroupObj(g_idx, groupList) {
          let levelObj = getLoginLevelObj(g_idx, groupList);
          if ( util.isEmpty(levelObj) ) {
              this.checkLevelFail();
          } else {
              this.checkLoginLevel(levelObj);
          }
        },
        checkLevelFail(errorMsg = '') {
            if(!errorMsg) {
                errorMsg = getLoginErrorMessage(this);
            }
            this.errorMsg = errorMsg;
            this.errorAlert(errorMsg);
            clearLoginState(this);
        },
        checkLevelSuccess(levelObj) {
          this.LevelClass.setterLevelObj(levelObj);
          this.$router.replace(this.redirect);
        },
        checkLoginLevel(levelObj) {
            if(isAllowedLoginGroupType(levelObj.type)) {
                this.checkLevelSuccess(levelObj);
            } else {
                this.checkLevelFail(getLoginErrorMessage(this));
            }
        },

    },
}
